import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi, useStrapiParams } from '@/hooks';
import { sidebarItems } from './sidebar';
import { ROUTES } from '@/constants';
import { SectionTitle, SectionIntro, CatalogCategoriesList, CatalogSearcher, CatalogProductList } from '@/components';
import type { CategoryCatalog, StrapiListRequest, StrapiListResponse } from '@/interfaces/strapi';
import { getCatalogCategories } from '@/services/strapi';

export const Catalogo = (): ReactElement => {
	const params = useStrapiParams({
		page: 1,
		pageSize: 12,
	});

	const { data, loading: loadingCategories } = useStrapiApi<StrapiListResponse<CategoryCatalog>, StrapiListRequest>(
		getCatalogCategories,
		{
			autoFetch: true,
			params,
		},
	);

	const categories = data?.list;
	usePageBreadcrumb([
		{ label: 'Academia Matritense', to: ROUTES.ACADEMIA_MATRITENSE_HISTORIA },
		{ label: 'Catálogo' },
	]);

	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	return (
		<div>
			<SectionTitle title="Catálogo" tag="h1" align="left" className="u-mb-16" />
			<SectionIntro text='Para encargar libros acceda al formulario "Solicitar libros", cumplimentado los títulos que desee adquirir. Precio con IVA incluido. No incluye los gastos de envío.' />

			<CatalogCategoriesList isLoading={loadingCategories} categories={categories} title="Materias" />

			<CatalogSearcher />

			{categories?.length && categories.map((cat) => <CatalogProductList key={cat.slug} category={cat} />)}
		</div>
	);
};
